import ToastifyStyle from "@/styles/components/ToastifyStyle";
import TimeAgo from "javascript-time-ago";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AppProviders from "./context/app-context";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import en from "javascript-time-ago/locale/en.json";
import { Auth0Provider } from "@auth0/auth0-react";

TimeAgo.addDefaultLocale(en);

async function startApp() {
  // Initalise app after the Meticulous recorder is ready, e.g.
  const container = document.getElementById("root") as HTMLElement;
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <AppProviders>
        <ToastifyStyle />
        <Auth0Provider
          domain={import.meta.env.REACT_APP_AUTH0_DOMAIN || ""}
          clientId={import.meta.env.REACT_APP_AUTH0_CLIENT_ID || ""}
          authorizationParams={{
            redirect_uri: import.meta.env.REACT_APP_AUTH0_REDIRECT_URI || "",
            audience: `https://${
              import.meta.env.REACT_APP_AUTH0_DOMAIN
            }/api/v2/`,
            scope: "openid profile email",
          }}
          useRefreshTokens={true}
          cacheLocation="localstorage"
        >
          <App />
        </Auth0Provider>
      </AppProviders>
    </React.StrictMode>,
  );
}

startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
